import {Component, inject, OnInit} from '@angular/core'
import {Router, RouterLink} from '@angular/router'
import {environment} from '../../../environments/environment'
import {MatCard, MatCardAvatar, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card'
import {MatIcon} from '@angular/material/icon'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {toObservable} from '@angular/core/rxjs-interop'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-login',
  templateUrl: './landing.component.html',
  imports: [
    MatCardTitle,
    MatCard,
    MatIcon,
    RouterLink,
    MatCardContent,
    MatCardHeader,
    MatCardAvatar
  ],
  styleUrls: ['./landing.component.scss']

})
export class LandingComponent implements OnInit {
  /**
   * Shows Ränter, to be removed!
   */
  public testMode = environment.testMode

  public readonly configService = inject(ConfigService)

  private readonly router = inject(Router)

  private readonly user$ = toObservable(this.configService.currentUser)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.user$.pipe(
      this.takeUntilDestroyed()
    ).subscribe(() => {
      if (!this.configService.isAdmin()) {
        this.router.navigate(['/']).then()
      }
      if (this.configService.roles().includes('renewalToolBinding') &&
        this.configService.roles().length === 1) {
        this.router.navigate(['/', 'bindings']).then()
      }
    })
  }
}
